/**
 * @generated SignedSource<<791547eba6851e841d97a76a19acdd6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteCategoryInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type Category_Delete_Mutation$variables = {
  input: DeleteCategoryInput;
};
export type Category_Delete_Mutation$data = {
  readonly deleteCategory: {
    readonly category: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type Category_Delete_Mutation$rawResponse = {
  readonly deleteCategory: {
    readonly category: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type Category_Delete_Mutation = {
  rawResponse: Category_Delete_Mutation$rawResponse;
  response: Category_Delete_Mutation$data;
  variables: Category_Delete_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Category_Delete_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCategoryPayload",
        "kind": "LinkedField",
        "name": "deleteCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Category_Delete_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCategoryPayload",
        "kind": "LinkedField",
        "name": "deleteCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "981a8f2e9f59cd9bd2da3b14523a8570",
    "id": null,
    "metadata": {},
    "name": "Category_Delete_Mutation",
    "operationKind": "mutation",
    "text": "mutation Category_Delete_Mutation(\n  $input: DeleteCategoryInput!\n) {\n  deleteCategory(input: $input) {\n    category {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "440bc1d185e237862cf154eddfb90b54";

export default node;
